(function () {
  'use strict';

  if (window.DeckauraReadingOfferGuide) return;

  var marker = '[data-reading-offer-guide]';
  var tierMarker = '[data-reading-tier-label]';
  var packageNames = {};
  var copyElement = document.getElementById('DeckauraReadingOfferCopy');
  if (copyElement) {
    try {
      var copy = JSON.parse(copyElement.textContent);
      ['essential', 'deeper', 'indepth'].forEach(function (tier) {
        if (copy.names && typeof copy.names[tier] === 'string') {
          packageNames[tier] = copy.names[tier];
        }
      });
    } catch (error) {
      packageNames = {};
    }
  }

  function packageName(tier) {
    return Object.prototype.hasOwnProperty.call(packageNames, tier) ? packageNames[tier] : null;
  }

  function labelTier(element) {
    var label = packageName(element.getAttribute('data-reading-tier-label'));
    element.setAttribute('data-deckaura-no-i18n', '');
    if (label && element.textContent !== label) element.textContent = label;
  }

  function applyLifePathScope(guide) {
    var config = window.DeckauraDeepReadingRuntimeConfig || {};
    if (config.canonicalPage !== '/pages/life-path-number-calculator') return;
    var tiers = ['essential', 'deeper', 'indepth'];
    var sources = tiers.map(function (tier) { return document.querySelector('[data-lpn-scope="' + tier + '"]'); });
    if (!sources.every(function (source) { return source && source.textContent.trim(); })) return;
    var outputs = guide.querySelectorAll('.reading-offer-guide__outputs > li');
    outputs.forEach(function (output, index) {
      if (!sources[index]) return;
      var label = packageName(tiers[index]) || '';
      var text = sources[index].textContent.trim();
      if (output.textContent === label + ': ' + text) return;
      var title = document.createElement('strong');
      title.textContent = label + ': ';
      output.replaceChildren(title, document.createTextNode(text));
    });
  }

  function mount(container) {
    if (!container || container.nodeType !== 1) return null;
    var existing = container.querySelector(':scope > .reading-offer-guide');
    if (existing) { applyLifePathScope(existing); return existing; }
    var template = document.getElementById('reading-offer-guide-template');
    if (!template || !template.content) return null;
    container.appendChild(template.content.cloneNode(true));
    var mounted = container.querySelector(':scope > .reading-offer-guide');
    if (mounted) applyLifePathScope(mounted);
    return mounted;
  }

  function mountAdded(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches(marker)) mount(node);
    node.querySelectorAll(marker).forEach(mount);
    if (node.matches(tierMarker)) labelTier(node);
    node.querySelectorAll(tierMarker).forEach(labelTier);
  }

  function start() {
    document.querySelectorAll(marker).forEach(mount);
    document.querySelectorAll(tierMarker).forEach(labelTier);
    var scope = document.getElementById('MainContent') || document.body;
    if (!scope || typeof MutationObserver === 'undefined') return;
    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.target.nodeType === 1 && record.target.matches(marker)) {
          mount(record.target);
        }
        if (record.target.nodeType === 1 && record.target.matches(tierMarker)) {
          labelTier(record.target);
        }
        record.addedNodes.forEach(mountAdded);
      });
    });
    observer.observe(scope, { childList: true, subtree: true });
  }

  window.DeckauraReadingOfferGuide = { mount: mount, packageName: packageName };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}());
